<p-toast position="top-center" key="login"></p-toast>
<div class="login-container bg-light">
  <div class="login-box" style="background-image: url('../../../assets/images/slider-video-2.avif')">
    <!--<h1 translate>APP_NAME</h1>-->
    <div class="pt-4">
      <!--<h6 class="d-inline-block">v{{ version }}</h6>-->
      <div class="d-inline-block ml-3">
        <app-language-selector></app-language-selector>
      </div>
    </div>
    <div class="container">
      <div class="card col-md-4 mt-3 mx-auto">
        <div class="card-body">
          <h4 class="card-title text-center mb-5">
            <!-- <i class="far fa-3x fa-user-circle text-muted"></i> -->
            <img class="img-fluid" src="../../assets/images/logo.png" />
          </h4>
          <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" novalidate>
            <div class="alert alert-danger" [hidden]="!error || isLoading" translate>
              Username or password incorrect.
            </div>
            <div class="form-group">
              <label class="d-block">
                <input
                  type="text"
                  class="form-control"
                  formControlName="username"
                  autocomplete="username"
                  [placeholder]="'User Name' | translate"
                />
                <span hidden translate>{{ 'User Name' | translate }}</span>
                <small
                  [hidden]="loginForm.controls.username.valid || loginForm.controls.username.untouched"
                  class="text-danger"
                  translate
                >
                  {{ 'Require Username' | translate }}
                </small>
              </label>
              <label class="d-block">
                <input
                  [type]="fieldPasswordType ? 'text' : 'password'"
                  class="form-control passwordField"
                  formControlName="password"
                  autocomplete="current-password"
                  [placeholder]="'Password' | translate"
                  required
                />
                <i
                  class="fa passwordShow"
                  [ngClass]="{
                    'fa-eye-slash': !fieldPasswordType,
                    'fa-eye': fieldPasswordType
                  }"
                  (click)="togglePasswordType()"
                ></i>
                <span hidden translate>Password</span>
                <small
                  [hidden]="loginForm.controls.password.valid || loginForm.controls.password.untouched"
                  class="text-danger"
                  translate
                >
                  {{ 'Require Password' | translate }}
                </small>
              </label>
              <div class="form-check">
                <!-- <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" formControlName="remember" />
                  <span translate>Remember me</span>
                </label> -->
              </div>
            </div>
            <button class="btn btn-primary w-100" type="submit" [disabled]="loginForm.invalid || isLoading">
              <i class="fas fa-cog fa-spin" [hidden]="!isLoading"></i>
              <span translate>Login</span>
            </button>
          </form>
          <div class="row">
            <div class="col-md-12 mt-3">
              <a routerLink="/forgot-password" class="forgotPassword">{{ 'Forgot password' | translate }}?</a>
              <span
                >{{ "Don't have one" | translate }},<a routerLink="/register"> {{ 'Register' | translate }}</a>
                {{ 'here' | translate }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
